export default __webpack_public_path__ + "images/e7c6b231d7f39ed58228087d007ceec7-fashion.jpg";